import { FulfillmentCutoffScheduleParser } from "@redotech/redo-model/checkouts/fulfillment-cutoff";
import { z } from "zod";

export const updateFulfillmentCutoffSchedule = {
  input: z.object({
    schedule: z.union([FulfillmentCutoffScheduleParser, z.null()]),
  }),
  output: z.null(),
};
